import { themeSelectStyles } from "components/shared/theme/themeSelectStyles";
import { themeContainer } from "helpers/redux";
import React from "react";
import { components } from "react-select";
import { Select as FormSelect } from "./form/select";

export class Select extends FormSelect {
    render() {
        return (
            <>
                {this.renderField()}
                {this.renderError()}
            </>
        );
    }
}

export default themeContainer(Select);

export const ValueContainer = (props) => {
    const { children, getValue, hasValue } = props;
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    const length = getValue().length;
    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    {length === 1 ? getValue()[0].label : `Выбрано (${length})`}
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

export const Option = (props) => {
    const { name, description } = props.data.option;
    return (
        <components.Option {...props}>
            {name} <small className="text-muted">{description}</small>
        </components.Option>
    );
};

export const OptionWithFederalSubject = (props) => {
    const { name, federalSubjectName } = props.data.option;
    return (
        <components.Option {...props}>
            {name}
            {federalSubjectName && (
                <>
                    <br />
                    <small className={props.isSelected ? "" : "text-muted"}>{federalSubjectName}</small>
                </>
            )}
        </components.Option>
    );
};

export const customFilterSelectStyles = {
    container: (styles) => ({ ...styles, width: "100%" }),
    control: (styles) => ({ ...styles, minHeight: "26px", fontSize: "14px" }),
    indicatorsContainer: (styles) => ({ ...styles, height: "26px" }),
    placeholder: (styles) => ({ ...styles, lineHeight: "18px", maxWidth: "calc(100% - 16px)", whiteSpace: "nowrap" }),
};

export const customStyles = {
    container: (styles) => ({ ...styles, width: "100%" }),
    control: (styles) => ({ ...styles, minHeight: "26px", fontSize: "14px" }),
    input: (styles) => ({ ...styles, height: "17px", paddingTop: 0, marginTop: 0 }),
    singleValue: (styles) => ({ ...styles, height: "18px", lineHeight: "18px", textAlign: "left" }),
    multiValue: (styles) => ({ ...styles, height: "18px", lineHeight: "14px", textAlign: "left" }),
    valueContainer: (styles) => ({ ...styles, lineHeight: "18px" }),
    indicatorsContainer: (styles) => ({ ...styles, height: "26px" }),
    dropdownIndicator: (styles) => ({ ...styles, padding: "4px" }),
    clearIndicator: (styles) => ({ ...styles, padding: "4px" }),
    indicatorSeparator: () => ({ display: "none" }),
    option: (styles) => ({ ...styles, fontSize: "14px" }),
    placeholder: (styles) => ({ ...styles, lineHeight: "18px", maxWidth: "calc(100% - 16px)", whiteSpace: "nowrap" }),
    menu: (styles) => ({ ...styles, zIndex: 11 }),
};

export const defaultSelectStylesProps = (theme) => {
    return {
        ...(theme
            ? {
                  ...themeSelectStyles(theme, customStyles),
              }
            : { ...customStyles }),
    };
};

export const defaultMultipleSelectProps = {
    isMulti: true,
    hideSelectedOptions: false,
    closeMenuOnSelect: false,
};

export const RecipientWithOrgOption = (props) => {
    const { fullNameOrEmail, organizationName } = props.data.option;
    return (
        <components.Option {...props}>
            {fullNameOrEmail}
            {organizationName && <small className="text-muted ml-1">({organizationName})</small>}
        </components.Option>
    );
};

export const RecipientWithOrgValueContainer = (props) => {
    const { children, getValue, hasValue } = props;
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    const value = getValue()[0];
    if (!value || !value.option) {
        return <components.ValueContainer {...props} />;
    }
    const { organizationName } = value.option;
    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    <div>
                        {value.label}
                        {organizationName && <small className="text-muted ml-2">({organizationName})</small>}
                    </div>
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};
